import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";

interface MobileProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Equivalente mobile do ProtectedRoute: sem sessão, manda para /m/login
 * (e não para /login do web), preservando a rota de origem para voltar após o login.
 */
export const MobileProtectedRoute: React.FC<MobileProtectedRouteProps> = ({ children }) => {
  const { t } = useTranslation("auth");
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-dvh w-full flex-col items-center justify-center gap-3 bg-background">
        <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-border border-t-accent-blue" />
        <p className="text-[14px] text-muted-foreground">{t("common.checkingSession")}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/m/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <>{children}</>;
};
